const publishEvent = (eventName, data) => {
  if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
    // console.log('✅ Track event:', eventName, data);
    window.Shopify.analytics.publish('custom_event', {
      name: eventName,
      data: data,
    });
  }

  // send gtag event
  if (typeof gtag === 'function') {
    gtag('event', eventName, data);
  }

  // send fbq event
  if (typeof fbq === 'function') {
    fbq('trackCustom', eventName, data);
  }
};

const trackFindStoreBtnClick = (eventName, el) => {
  const data = {
    page_url: window.location.href,
    product_title: el.getAttribute('data-product-title') || 'Unknown',
    product_id: el.getAttribute('data-product-id') || 'Unknown',
  };
  publishEvent(eventName, data);
};

const trackGetPluginBtnClick = (eventName, el) => {
  const data = {
    page_url: window.location.href,
    product_title: el.dataset.productTitle || 'Unknown',
    product_id: el.dataset.productId || 'Unknown',
  };
  publishEvent(eventName, data);
};

// Track custom events using Shopify Analytics API
document.addEventListener('DOMContentLoaded', function () {
  if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
    document.querySelectorAll('[data-track-event]').forEach(function (el) {
      const eventType = el.getAttribute('data-track-event');
      const eventName = el.getAttribute('data-track-event-name');
      if (!eventName || !eventType) return;

      if (eventType === 'click') {
        el.addEventListener('click', function () {
          if (eventName === 'find_store_btn_click') {
            trackFindStoreBtnClick(eventName, el);
          }
          else if (eventName === 'get_plugin_btn_click') {
            trackGetPluginBtnClick(eventName, el);
          }
        });
      }
    });
  }
});
